export default({ request }) => ({
    materialOptionsListApi(data = {}) {
        return request({
            url: '/master/materialMetadataOptions/list',
            method: 'post',
            data,
        })
    },
    materialOptionsDetailApi(data = {}) {
        return request({
            url: '/master/materialMetadataOptions/detail',
            method: 'post',
            data,
        })
    },
    materialOptionsSaveApi(data = {}) {
        return request({
            url: '/master/materialMetadataOptions/save',
            method: 'post',
            data,
        })
    },
    materialOptionsDelApi(data = {}) {
        return request({
            url: '/master/materialMetadataOptions/del',
            method: 'post',
            data,
        })
    },
})